import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Header from "Page/common/components/Header";
import styles from "./QnaPost.module.css";

export default function QnaPost() {
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [pwCheck, setPwCheck] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    if (name === "") alert(" 입력하세요");
    else if (pw === "" || pwCheck === "") alert("비밀번호를 입력하세요");
    else if (email === "") alert("이메일을 입력하세요");
    else if (tel === "") alert("전화번호를 입력하세요");
    else if (title === "") alert("제목을 입력하세요");
    else if (content === "") alert("내용을 입력하세요");
    else if (pw !== pwCheck) alert("비밀번호를 확인하세요");
    else {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/support/qna/article`,
        {
          user_name: name,
          user_email: email,
          user_tel: tel,
          pw: pw,
          title: title,
          content: content,
        }
      );

      console.log(response);
      if (response.status == 200) {
        alert("문의사항이 등록되었습니다");
        navigate(`/support/qna/article/${response.data.insertId}`);
      }
    }
  };
  const handleInputName = (e) => {
    setName(e.target.value.trim());
  };
  const handleInputPw = (e) => {
    setPw(e.target.value.trim());
  };
  const handleInputPwCheck = (e) => {
    setPwCheck(e.target.value.trim());
  };
  const handleInputTel = (e) => {
    setTel(e.target.value.trim());
  };
  const handleInputEmail = (e) => {
    setEmail(e.target.value.trim());
  };
  const handleInputTitle = (e) => {
    setTitle(e.target.value.trim());
  };
  const handleInputContent = (e) => {
    setContent(e.target.value.trim());
  };

  return (
    <div className={styles.QnaPost}>
      <Header title="Q&A 작성" />
      <form>
        <div>
          <div>작성자</div>
          <input type="text" name="name" onChange={handleInputName} />

          <div>비밀번호</div>
          <input
            type="password"
            name="pw"
            autoComplete="new-password"
            onChange={handleInputPw}
          />

          <div>비밀번호 확인</div>
          <input
            type="password"
            name="pwCheck"
            autoComplete="new-password"
            onChange={handleInputPwCheck}
          />

          <div>전화번호</div>
          <input type="number" name="tel" onChange={handleInputTel} />

          <div>이메일</div>
          <input type="email" name="email" onChange={handleInputEmail} />

          <div>글 제목</div>
          <input type="text" name="title" onChange={handleInputTitle} />

          <div>내용</div>
          <input type="text" name="content" onChange={handleInputContent} />
        </div>

        <button type="submit">등록하기</button>
      </form>
    </div>
  );
}
